import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { cancelAllAcceptedNetworkElements } from '@api/manageNetworkElementConfigurations';

import {
	INetworkElementConfigurationsFilterAction,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_CANCEL_ALL_ACCEPTED } from '@constants/queryKeys';

interface IUseMutateChangeMonitoringCancelAllAcceptedReturned {
	isLoadingCancelAllAccepted: boolean;
	cancelAllAccepted: UseMutateAsyncFunction<
		any, any, INetworkElementConfigurationsFilterAction, any
	>;
}

const useMutateChangeMonitoringCancelAllAccepted = (
	onSuccess?: () => void,
): IUseMutateChangeMonitoringCancelAllAcceptedReturned => {
	const {
		isLoading,
		mutateAsync,
	} = useMutation<INetworkElementConfigurationsFilterAction>({
		mutationKey: [NETWORK_ELEMENT_CANCEL_ALL_ACCEPTED],
		mutationFn: cancelAllAcceptedNetworkElements,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess,
	});

	return {
		isLoadingCancelAllAccepted: isLoading,
		cancelAllAccepted: mutateAsync,
	};
};

export default useMutateChangeMonitoringCancelAllAccepted;
